import cqrsApiService from "../../../shared/services/cqrsApiService.js";

export default {
  upload(projectId, mrmrStatementPeriodId, filename, mimeType, fileContent, vm) {
    return new Promise((resolve, reject) => {
      let binary = '';
      const bytes = new Uint8Array(fileContent);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      const base64FileContent = btoa(binary);
      cqrsApiService.Post("/Geo/MRMR/StagingVariances/upload", { projectId, mrmrStatementPeriodId, filename, mimeType, fileContent: base64FileContent }, vm).then((response) => {
        resolve(response.data.model)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  confirmSubmission(uploadId, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("/Geo/MRMR/StagingVariances/submit", { uploadId }, vm).then((response) => {
        resolve(response.data.model)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  findPreviousStatement(uploadId, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("/Geo/MRMR/StagingVariances/findPreviousStatement", { params: { uploadId } }, vm).then((response) => {
        resolve(response.data.model)
      }).catch((error) => {
        reject(error)
      });
    });
  }
}

